import { baseRoutes } from '@routes/helpers/baseRoutes.ts';
import { routesPaths } from '@routes/helpers/constants.ts';
import { AppRouteConfig } from '@routes/route';

export const approvalsRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: baseRoutes.approvals.root,
    lazyImport: () => import('../../domains/protected/approvals/ApprovalsRoute.tsx'),
    requiresAuth: true,
    resourceId: 'approval',
    children: [
      {
        index: true,
        lazyImport: () =>
          import('../../domains/protected/approvals/pages/approvals-list/ApprovalsListRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.approvals.details,
        lazyImport: () =>
          import('../../domains/protected/approvals/pages/approval-details/ApprovalDetailsRoute.tsx'),
        nav: {
          backTo: routesPaths.approvals.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: '*',
        redirectTo: routesPaths.approvals.root
      }
    ]
  }
];
